import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import stylesJS from '@/assets/styles.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'switchGroup',
  props: {
  styles: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: false
  },
  disable: {
    type: Boolean,
    default: false
  },
  circle: {
      type: Boolean,
      default: false
    }  
},
  setup(__props) {

const props = __props

const hover = ref(false)
function hoverOn() {
  hover.value = true   
}
function hoverOff() {
  hover.value =  false      
}

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)

  let ipadButton = importOBJ.padButton  || "m"
  let padButton = props.circle ? 'pad-' : 'padButton-'
  ipadButton = padButton + ipadButton

  // State
  let sShadow  = ''
  if (hover.value) {sShadow = 'shadow'}
  let sColors = ''
  sColors = props.active ? 'active' : props.disable ? 'disable' : 'inactive'

  return [ipadButton, 'component', 'cursor-action', 'rnd-switch', sShadow, sColors, 'border']
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classList.value),
    onMouseover: hoverOn,
    onMouseleave: hoverOff
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 34))
}
}

})